{
  "manifest_version": 3,
  "name": "WB ERP 1688 / WB 采集助手",
  "description": "1688 与 WB 搜索页、详情页按需采集；WB 尺码价格库存分别保存，缺失资料进入待完善草稿。",
  "version": "1.4.3",
  "permissions": [
    "activeTab",
    "scripting",
    "storage"
  ],
  "optional_host_permissions": [
    "https://*/*",
    "http://localhost/*",
    "http://127.0.0.1/*",
    "http://[::1]/*"
  ],
  "action": {
    "default_title": "WB ERP 采集助手",
    "default_popup": "popup.html"
  },
  "background": {
    "service_worker": "background.js"
  },
  "content_scripts": [
    {
      "matches": [
        "https://1688.com/*",
        "https://*.1688.com/*",
        "https://wildberries.ru/*",
        "https://www.wildberries.ru/*"
      ],
      "js": [
        "content.js"
      ],
      "run_at": "document_idle"
    }
  ],
  "host_permissions": [
    "https://1688.com/*",
    "https://*.1688.com/*",
    "https://wildberries.ru/*",
    "https://www.wildberries.ru/*"
  ]
}
